import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EngineeringIcon(props: IconProps) {
    return <Icon {...props} iconKey={"engineering"}/>
}
